// GENERATED by scripts/generate_dashboard_v2_currency_helper.py; DO NOT EDIT.
// Source: web/dashboard/src/lib/currency-decimals.ts
// Source SHA256: fb900624465b2d31f52aeb6fc0291ff2978c4d01754ff898d100daab81d68e37

export const CURRENCY_DECIMALS: Record<string, number> = {
  USD: 2, EUR: 2, GBP: 2, CAD: 2, AUD: 2, NZD: 2, CHF: 2,
  JPY: 0, KRW: 0, VND: 0,
  BHD: 3, KWD: 3, OMR: 3,
  BDT: 2, INR: 2, MXN: 2, BRL: 2, ZAR: 2, SGD: 2, HKD: 2,
  SEK: 2, NOK: 2, DKK: 2, PLN: 2, CZK: 2, HUF: 2, RON: 2,
  PHP: 2, THB: 2, MYR: 2, IDR: 2, TWD: 2, ILS: 2, TRY: 2,
  AED: 2, SAR: 2, QAR: 2, EGP: 2, NGN: 2, KES: 2, GHS: 2,
  COP: 2, CLP: 0, PEN: 2, ARS: 2, UYU: 2,
};

export function getDecimalsForCurrency(currency: string): number {
  return CURRENCY_DECIMALS[currency] ?? 2;
}

export function hasNativeCurrencyPrecision(currency: unknown): currency is string {
  return typeof currency === 'string' && /^[A-Z]{3}$/.test(currency)
    && Object.prototype.hasOwnProperty.call(CURRENCY_DECIMALS, currency);
}

export function safeMajorToMinorUnits(amount: unknown, currency: unknown): number | null {
  if (!hasNativeCurrencyPrecision(currency) || typeof amount !== 'number' || !Number.isFinite(amount)) return null;
  const minorUnits = majorToMinorUnits(amount, currency);
  const scaledAmount = amount * Math.pow(10, CURRENCY_DECIMALS[currency]);
  return Number.isSafeInteger(minorUnits) && Math.abs(scaledAmount - minorUnits) < 0.000001 ? minorUnits : null;
}

export function safeMinorToMajorUnits(amount: unknown, currency: unknown): number | null {
  if (!hasNativeCurrencyPrecision(currency) || typeof amount !== 'number' || !Number.isSafeInteger(amount)) return null;
  const majorUnits = minorUnitsToMajor(amount, currency);
  return safeMajorToMinorUnits(majorUnits, currency) === amount ? majorUnits : null;
}

/**
 * Precision-aware minor-units → major-units conversion.
 *
 * The canonical, framework-agnostic counterpart to IntlProvider's
 * `formatCurrency` scaling step, for surfaces that need a bare numeric
 * major value (editable form fields, public pages with their own
 * Intl.NumberFormat). NEVER hardcode `/100` — JPY/KRW (0 decimals) and
 * BHD/KWD/OMR (3 decimals) would render 100×/10× wrong (DRIFT-922).
 */
export function minorUnitsToMajor(amountInMinorUnits: number, currency: string): number {
  return amountInMinorUnits / Math.pow(10, getDecimalsForCurrency(currency));
}

/**
 * Precision-aware major-units → minor-units conversion (round-trip
 * inverse of `minorUnitsToMajor`). Used when a user-entered major amount
 * is parsed back to the integer `*_minor_units` wire value. NEVER
 * hardcode `*100` (DRIFT-922).
 */
export function majorToMinorUnits(amountInMajorUnits: number, currency: string): number {
  return Math.round(amountInMajorUnits * Math.pow(10, getDecimalsForCurrency(currency)));
}
